'use strict';

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.promise");

var _regeneratorRuntime = require("/home/runner/work/tcg-legal.com/tcg-legal.com/HP001/v001/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/home/runner/work/tcg-legal.com/tcg-legal.com/HP001/v001/node_modules/@babel/runtime/helpers/asyncToGenerator");

require("core-js/modules/es6.date.now");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.map");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.is-finite");

require("core-js/modules/es6.function.name");

var _classCallCheck = require("/home/runner/work/tcg-legal.com/tcg-legal.com/HP001/v001/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/home/runner/work/tcg-legal.com/tcg-legal.com/HP001/v001/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/tcg-legal.com/tcg-legal.com/HP001/v001/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/runner/work/tcg-legal.com/tcg-legal.com/HP001/v001/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/home/runner/work/tcg-legal.com/tcg-legal.com/HP001/v001/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var AbortError = /*#__PURE__*/function (_Error) {
  _inherits(AbortError, _Error);

  function AbortError() {
    var _this;

    _classCallCheck(this, AbortError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbortError).call(this, 'Throttled function aborted'));
    _this.name = 'AbortError';
    return _this;
  }

  return AbortError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var pThrottle = function pThrottle(_ref) {
  var limit = _ref.limit,
      interval = _ref.interval,
      strict = _ref.strict;

  if (!Number.isFinite(limit)) {
    throw new TypeError('Expected `limit` to be a finite number');
  }

  if (!Number.isFinite(interval)) {
    throw new TypeError('Expected `interval` to be a finite number');
  }

  var queue = new Map();
  var currentTick = 0;
  var activeCount = 0;

  function windowedDelay() {
    var now = Date.now();

    if (now - currentTick > interval) {
      activeCount = 1;
      currentTick = now;
      return 0;
    }

    if (activeCount < limit) {
      activeCount++;
    } else {
      currentTick += interval;
      activeCount = 1;
    }

    return currentTick - now;
  }

  var strictTicks = [];

  function strictDelay() {
    var now = Date.now();

    if (strictTicks.length < limit) {
      strictTicks.push(now);
      return 0;
    }

    var earliestTime = strictTicks.shift() + interval;

    if (now >= earliestTime) {
      strictTicks.push(now);
      return 0;
    }

    strictTicks.push(earliestTime);
    return earliestTime - now;
  }

  var getDelay = strict ? strictDelay : windowedDelay;
  return function (function_) {
    var throttled = function throttled() {
      var _this2 = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (!throttled.isEnabled) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", function_.apply(_this2, args));

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      }

      var timeout;
      return new Promise(function (resolve, reject) {
        var execute = function execute() {
          resolve(function_.apply(_this2, args));
          queue["delete"](timeout);
        };

        timeout = setTimeout(execute, getDelay());
        queue.set(timeout, reject);
      });
    };

    throttled.abort = function () {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = queue.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var timeout = _step.value;
          clearTimeout(timeout);
          queue.get(timeout)(new AbortError());
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      queue.clear();
      strictTicks.splice(0, strictTicks.length);
    };

    throttled.isEnabled = true;
    return throttled;
  };
};

module.exports = pThrottle;
module.exports.AbortError = AbortError;